// @flow
import React, { useState } from 'react';
import type { Node } from 'react';
import type { TackleRod } from '../../models/tackle_rods/TackleRod';
import { TACKLE_ROD_COLUMN_DEFINITIONS } from '../../models/tackle_rods/TackleRod';
import SpecModal from './SpecModal';

type Props = {
  tackleRod: TackleRod,
};

function RodSpeckCarouselRoot(props: Props): Node {
  return <RodSpeckCarousel {...props} />;
}

function RodSpeckCarousel({ tackleRod }: Props) {
  const [active, setActive] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);

  const onScroll = () => {
    setActive(true);
  };

  const onOpen = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <>
      <section>
        <div className="display_flex justify_between align_center">
          <h2 className="headline_sub mb_3">
            スペック詳細
            <i className="fa fa-question-circle-o" onClick={onOpen}></i>
          </h2>
        </div>

        <div className="mt_3">
          <div data-scope-path="tacklebox/models/speck_carousel_component">
            <div className="models_speck_carousel_container">
              <div className="models_speck_carousel" onScroll={onScroll}>
                {TACKLE_ROD_COLUMN_DEFINITIONS.map(column => {
                  if (column.key === 'lowest_price') return;
                  return (
                    tackleRod[column.key] && (
                      <div className="carousel_item" key={column.key}>
                        <div className="models_speck_carousel_item_header">
                          {column.label}
                        </div>
                        {tackleRod[column.key]}
                      </div>
                    )
                  );
                })}
              </div>

              <div
                className={`models_speck_carousel_guide ${
                  active ? 'active' : ''
                }`}
              >
                <i className="fa fa-chevron-right" aria-hidden="true"></i>
              </div>
            </div>
            {tackleRod.remarks && (
              <div className="remark">
                <div className="remark_label">備考</div>
                <div className="remark_content">{tackleRod.remarks}</div>
              </div>
            )}
          </div>
        </div>
      </section>

      <SpecModal visible={visible} onClose={onClose} />
    </>
  );
}

export default RodSpeckCarouselRoot;
